// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.carrier.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    version: '1.000.0',
    production: false,
    errMsg: 'Failed to complete. Please try again.',
    partner: true,
    config: {
        "stage": "prod",
        "appName": "CPM",
        "multiRegion": true,
        "defaultRegion": "1",
        "regionsList": ["1", "2"],
        "auth": {
            "caretakerUrl": "https://caretaker.carrier.service.75f.io/api/v1",
            "gatekeeperUrl": "https://login.carrierclimavision.com/api/v1",
        },
        "1" : {
            "regionName": "North America",
            "haystackUrl": "https://silo.carrier.service.75f.io/",
            "tagsUrl": "https://silo.carrier.service.75f.io/v2/sitePointTags",
            "cpmUrl": "https://chiller-plant.carrier.service.75f.io/",
            "alertsUrl": "https://alerts.carrier.service.75f.io/",
            "pasUrl": `https://portfolio-analytics.carrier.service.75f.io/`,
        },
        "2" : {
            "regionName": "Europe",
            "haystackUrl": "https://silo.carrier-eu.service.75f.io/",
            "tagsUrl": "https://silo.carrier-eu.service.75f.io/v2/sitePointTags",
            "cpmUrl": "https://chiller-plant.carrier-eu.service.75f.io/",
            "alertsUrl": "https://alerts.carrier-eu.service.75f.io/",
            "pasUrl": `https://portfolio-analytics.carrier-eu.service.75f.io/`,
        }
    }
};